import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/bookmarksActions';
import ServerError from '../ServerError';
import Modal from '../Modal/Modal';
import MultiSelect from 'react-multi-select-component';
import { FormattedMessage } from 'react-intl';

// let fileReader;
const overrideStrings = {
  selectSomeItems: 'Vyber',
  allItemsAreSelected: 'Vsichni',
  selectAll: 'Pro vsechny',
  search: 'Hledat',
};

export class Bookmarks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBookmarkForm: false,
      showDeleteConfirmation: false,
      bookmarkId: '',
      bookmarkName: '',
      bookmarkUsers: [],
      bookmarkVins: [],
      bookmarkError: '',
    };
  }

  componentDidMount() {
    this.props.actions.loadBookmarks();
    this.props.actions.loadUsers();
  }

  // handleFileRead = () => {
  //   const content = fileReader.result.replace(/\r/g,'').split('\n');
  //   this.setState({
  //     bookmarkVins: content,
  //   });
  // }

  // handleFileChosen = (event) => {
  //   const file = event.target.files[0];
  //   fileReader = new FileReader();
  //   fileReader.onloadend = this.handleFileRead;
  //   fileReader.readAsText(file);
  //   event.target.value = null;
  // }

  // setRef = (ref) => {
  //   this.setRef = ref;
  // }

  getUsers = (bookmark) => {
    let userNames = '';
    const users = this.props.users;
    if (bookmark.users) {
      bookmark.users.map((userId) => {
        const user = users.find((u) => u.id === userId);
        if (user) {
          userNames = userNames + (userNames ? ', ' : '') + user.name;
        }
      });
    }
    return userNames;
  };

  newBookmark = () => {
    this.setState({
      showBookmarkForm: true,
      bookmarkId: '',
      bookmarkName: '',
      bookmarkUsers: [],
      bookmarkVins: [],
    });
  };

  cancelBookmark = () => {
    this.setState({
      showBookmarkForm: false,
      showDeleteConfirmation: false,
      bookmarkError: '',
    });
  };

  saveBookmark = () => {
    // if (!this.state.bookmarkName) {
    //   this.setState({bookmarkError: 'Chybi jmeno'});
    //   return;
    // }
    // if (this.state.bookmarkVins.length === 0) {
    //   this.setState({bookmarkError: 'Chybi viny'});
    //   return;
    // }
    this.setState({
      showBookmarkForm: false,
      bookmarkError: '',
    });
    const bookmark = {
      id: this.state.bookmarkId,
      name: this.state.bookmarkName,
      users: this.state.bookmarkUsers,
      // 'vins':this.state.bookmarkVins,
    };
    this.props.actions.saveBookmark(bookmark);
  };

  editBookmark = (bookmark) => {
    this.setState({
      showBookmarkForm: true,
      bookmarkId: bookmark.id,
      bookmarkName: bookmark.name,
      bookmarkUsers: bookmark.users,
      // bookmarkVins: bookmark.vins,
    });
  };

  deleteBookmark = (bookmark) => {
    this.setState({
      showDeleteConfirmation: true,
      bookmarkId: bookmark.id,
      bookmarkName: bookmark.name,
    });
  };

  confirmDeleteBookmark = () => {
    const bookmark = this.props.bookmarks.find(
      (b) => b.id === this.state.bookmarkId
    );
    this.props.actions.deleteBookmark(bookmark);
    this.setState({
      showDeleteConfirmation: false,
      bookmarkId: '',
      bookmarkName: '',
    });
  };

  setSelected = (selected) => {
    const users = [];
    selected.map((user) => users.push(user.value));
    this.setState({
      bookmarkUsers: users,
    });
  };

  filterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }
    const re = new RegExp(filter, 'i');
    return options.filter(({ label }) => label && label.match(re));
  };

  handleChange = (event) => {
    let value = this.state;
    value[event.target.id] = event.target.value;
    this.setState(value);
  };

  renderBookmarkDialog() {
    const options = [];
    if (this.props.users) {
      this.props.users.map((user) => {
        options.push({ label: user.name, value: user.id });
      });
    }
    const selected = [];
    if (this.state.bookmarkUsers) {
      this.state.bookmarkUsers.map((user) => {
        selected.push({ value: user });
      });
    }

    return (
      <Modal
        header={this.state.bookmarkId ? 'Uprava zalozky' : 'Nova zalozka'}
        closeFunction={() => this.cancelBookmark()}
        closeLabel="Zrusit"
        confirmFunction={() => this.saveBookmark()}
        confirmLabel="OK"
      >
        {this.state.bookmarkError && (
          <div className="my-3 p-3 bg-white rounded shadow-sm">
            <div className="row" style={{ color: 'red' }}>
              <div className="col-sm-12 col-md-12 font-weight-bold text-center">
                {this.state.bookmarkError}
              </div>
            </div>
          </div>
        )}
        <div className="my-3 p-3 bg-white rounded shadow-sm">
          <div className="row">
            <div className="col-sm-6 col-md-6 font-weight-bold">
              <FormattedMessage id="app.bookmark.country" />:
            </div>
            <div className="col-sm-6 col-md-6">
              <input
                id="bookmarkId"
                type="text"
                value={this.state.bookmarkId}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
          </div>
        </div>
        <div className="my-3 p-3 bg-white rounded shadow-sm">
          <div className="row">
            <div className="col-sm-6 col-md-6 font-weight-bold">
              <FormattedMessage id="app.bookmark.name" />:
            </div>
            <div className="col-sm-6 col-md-6">
              <input
                id="bookmarkName"
                type="text"
                value={this.state.bookmarkName}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
          </div>
        </div>
        <div className="my-3 p-3 bg-white rounded shadow-sm">
          <div className="row">
            <div className="col-sm-6 col-md-6 font-weight-bold">Uzivatele</div>
            <div className="col-sm-6 col-md-6">
              <MultiSelect
                options={options}
                value={selected}
                onChange={this.setSelected}
                overrideStrings={overrideStrings}
                filterOptions={this.filterOptions}
                labelledBy={'Vyber adminu'}
              />
            </div>
          </div>
        </div>
        {/* <div className="my-3 p-3 bg-white rounded shadow-sm">
          <div className="row">
            <div className="d-none">
              <input id="fileDialog" type="file" accept=".csv" ref={this.setRef} onChange={e => this.handleFileChosen(e)} />
            </div>
            <div className="col-sm-6 col-md-6 font-weight-bold">
              <p className="imageButton" onClick={() => this.ref.fileUploader.click()}>CSV soubor 📁</p>
            </div>
            <div className="col-sm-6 col-md-6">{this.state.bookmarkVins.length} vinu</div>
          </div>
        </div> */}
      </Modal>
    );
  }

  render() {
    console.log(this.state);
    if (this.props.error) {
      return <ServerError error={this.props.error} />;
    }
    return (
      <main role="main" className="container-fluid">
        {this.state.showBookmarkForm && this.renderBookmarkDialog()}
        {this.state.showDeleteConfirmation && (
          <Modal
            header="Potvrzeni"
            closeFunction={this.cancelBookmark}
            closeLabel="Ne"
            confirmFunction={this.confirmDeleteBookmark}
            confirmLabel="Ano"
          >
            <div>Opravdu chcete smazat zalozku {this.state.bookmarkName}</div>
          </Modal>
        )}
        <div className="my-3 p-3 bg-white rounded shadow-sm">
          {this.props.bookmarks &&
            this.props.bookmarks.map((bookmark, i) => (
              <div key={i} className="row row-odd">
                <div className="col-sm-8 col-md-3">{bookmark.name}</div>
                <div className="col-sm-8 col-md-6">
                  {this.getUsers(bookmark)}
                </div>
                {/* <div className="col-sm-8 col-md-1">
                <p className="imageButton" onClick={() => this.setState({showVins:bookmark.vins})}>🚗</p>
              </div> */}
                <div className="col-sm-8 col-md-1">
                  <p
                    className="imageButton"
                    onClick={() => this.deleteBookmark(bookmark)}
                  >
                    🗑
                  </p>
                </div>
                <div className="col-sm-8 col-md-1">
                  <p
                    className="imageButton"
                    onClick={() => this.editBookmark(bookmark)}
                  >
                    ✏
                  </p>
                </div>
              </div>
            ))}
        </div>
        <div className="my-3 p-3 bg-white rounded shadow-sm">
          <p
            className="imageButton text-center"
            onClick={() => this.newBookmark()}
          >
            ➕
          </p>
        </div>
        {/* {this.state.showVins &&
          <Modal header="Seznam vinu" closeFunction={() => this.setState({showVins:''})} closeLabel="Zavrit">{this.state.showVins.join(', ')}</Modal>
        } */}
      </main>
    );
  }
}

Bookmarks.propTypes = {
  actions: PropTypes.object.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  bookmarks: PropTypes.array,
  users: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    loading: state.feedbacks.loading,
    error: state.feedbacks.error,
    bookmarks: state.bookmarks.bookmarks,
    users: state.bookmarks.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Bookmarks);
